// extracted by mini-css-extract-plugin
export var active = "_67-a";
export var activeIndicator = "_67-9";
export var disabled = "_67-b";
export var fullWidth = "_67-2";
export var lg = "_67-7";
export var md = "_67-6";
export var redoButtonTabGroup = "_67-0";
export var sm = "_67-5";
export var tabButton = "_67-4";
export var tabButtonsContainer = "_67-1";
export var themeDestructive = "_67-d";
export var themeNormal = "_67-c";
export var themeSuccess = "_67-e";
export var xl = "_67-8";
export var xs = "_67-3";